
































































































import { Component, Vue } from 'vue-property-decorator';
import storage from '../utils/storage';
import moment from 'moment';
import Loading from '../components/Loading.vue';
@Component({
  components: {
    Loading,
  },
})
export default class Gift extends Vue {
  private user: any;
  private Keyword: string = '';
  private handle: string = 'NO';
  // private teamUrl: string = 'http://156.232.6.221:3900/';
  private beforeTime: any = moment(new Date()).subtract(1, 'months').format('YYYY-MM-DD');
  private afterTime: any = moment(new Date()).format('YYYY-MM-DD');
  private dataTime: any = [this.beforeTime, this.afterTime];
  private dateFormat = 'YYYY-MM-DD';
  private dateFormathms = 'YYYY-MM-DD HH:mm:ss';
  private spinning: boolean = false;
  private brandJson: any = [];
  private pickerDate: any;
  private dataJson: any = [];
  private currentPage: number = 1;
  private totalPages: number = 1;
  private rateType: string = 'ALL';
  private accountType: string = 'ALL';
  private moment: any = moment;
  private HandleArr: any[] = [
    {
      name: 'ALL',
      isD: false,
    },
    {
      name: 'YES',
      isD: false,
    },
    {
      name: 'NO',
      isD: false,
    },
  ];
  private sortArr: any[] = [
    {
      name: 'ALL',
      isD: false,
    },
    {
      name: 'PASS',
      isD: false,
    },
    {
      name: 'WAIT',
      isD: false,
    },
  ];
  private mounted() {
    this.user = storage.get('user');
    if (this.user) {
      this.getData();
      this.getAccountBrand();
    } else {
     this.$router.push({
        path: '/login',
      });
    }
  }
  private changeTeamUrl(serveIP: string, imgUrl: string) {
    const url = serveIP + imgUrl;
    return url;
  }
  private onPaginationChange(value: number) {
    this.currentPage = value;
    this.getData();
  }
  private isHandel(str: string): boolean {
    if (str === '1') {
      return true;
    } else {
      return false;
    }
  }
  private returnGift(selectGift: string): string {
    if (selectGift === '9') {
      return 'product';
    } else {
      return '$' + selectGift;
    }
  }
  private async checkPass(id: string, orderID: string) {
    const that = this;
    this.spinning = true;
    const url: string = '/api/checkPass';
    const args = {
      id,
      orderID,
    };
    this.axios.post(url, args).then((res: any) => {
      const data = res.data;
      if (data && data.code === 12) {
        // console.log(res.data);
        that.getData();
      }
    });
  }
  private changeKeyword(): void {
    this.changeCurrentPage();
  }
  private rateTypeChange(value: string): void {
    this.rateType = value;
    this.changeCurrentPage();
  }
  private HandleTypeChange(value: string): void {
    this.handle = value;
    this.changeCurrentPage();
  }
  private accountChange(value: string): void {
    this.accountType = value;
    this.changeCurrentPage();
  }
  private async getData() {
    this.dataJson.splice(0, this.dataJson.length);
    const that = this;
    this.spinning = true;
    const url: string = '/api/getGift';
    const dataTime = [moment(this.dataTime[0]).format('YYYY-MM-DD HH:mm:ss'), this.dataTime[1] + ' 23:59:59'];
    const args = {
      currentPage: this.currentPage, // 请求的页数
      handle: this.handle,
      rate: this.rateType, // ALL PASS WAIT
      time: dataTime,
      team: this.user.team,
      accountBrand: this.accountType,
      Keyword: this.Keyword,
    };
    try {
      const data = await this.axios.post(url, args);
      that.dataJson = data.data.data;
      this.totalPages = Number(data.data.totalPages);
    } catch (err) {
      that.dataJson = [];
      this.totalPages = 1;
    }
    this.spinning = false;
  }
  private async getAccountBrand() {
    const that = this;
    this.brandJson.splice(0, this.brandJson.length);
    const brandJson = [{brand: 'ALL'}];
    const url: string = '/api/getAccountBrand';
    const args = {
      team: this.user.team,
    };
    const data = await this.axios.post(url, args);
    if (data.data.code === 12) {
      const d = data.data.data;
      d.forEach((element: any ) => {
        brandJson.push(element);
      });
      that.brandJson = brandJson;
    }

  }
  private utc2beijing(utcDatetime: string) {
    // 转为正常的时间格式 年-月-日 时:分:秒
    const TPos = utcDatetime.indexOf('T');
    const ZPos = utcDatetime.indexOf('Z');
    const yearMonthDay = utcDatetime.substr(0, TPos);
    const hourMinuteSecond = utcDatetime.substr(TPos + 1, ZPos - TPos - 1);
    const newDatetime = yearMonthDay + ' ' + hourMinuteSecond; // 2017-03-31 08:02:06
    // 处理成为时间戳
    let timestamp: any = new Date(Date.parse(newDatetime));
    timestamp = timestamp.getTime();
    timestamp = timestamp / 1000;
    // 增加8个小时，北京时间比utc时间多八个时区
    timestamp = timestamp + 8 * 60 * 60;
    // 时间戳转为时间
    const beijingDatetime = new Date(parseInt(timestamp, 10) * 1000).toLocaleString();
    return beijingDatetime;  // 2017-03-31 16:02:06
  }
  private onPickerChange(date: any, dateString: string) {
    // console.log(date, dateString);
    this.dataTime = dateString;
    this.changeCurrentPage();
  }
  private changeCurrentPage() {
    this.currentPage = 1;
  }
  private getCurrentStyle(current: any, today: any): any {
    const style: any = {};
    if (current.date() === 1) {
      style.border = '1px solid #1890ff';
      style.borderRadius = '50%';
    }
    return style;
  }
  private emitEmpty() {
    const inputBox: HTMLInputElement = this.$refs.KeywordInput as HTMLInputElement;
    inputBox.focus();
    this.Keyword = '';
    this.changeCurrentPage();
  }
  private adsAdd(data: any) {
    let ads = '';
    if (data.shipAddress2) {
      if (data.shipAddress3) {
        ads = data.userName + '\r' + data.shipAddress1 + '\r' + data.shipAddress2
            + '\r' + data.shipAddress3 + '\r' + data.shipCity + '\r'
            + data.shipState + '\r' + data.shipCountry + '\r' + data.shipPostalCode;
      } else {
        ads = data.userName + '\r' + data.shipAddress1 + '\r' + data.shipAddress2
            + '\r' + data.shipCity + '\r'
            + data.shipState + '\r' + data.shipCountry + '\r' + data.shipPostalCode;
      }
    } else {
      ads = data.userName + '\r' + data.shipAddress1 + '\r' + data.shipCity + '\r'
            + data.shipState + '\r' + data.shipCountry + '\r' + data.shipPostalCode;
    }
    return ads;
  }
  private copyInfo(id: string) {
    const Url: HTMLInputElement = document.getElementById(id.trim()) as HTMLInputElement;
    Url.select();
    document.execCommand('Copy');
    this.$message.info('Copy Success !!');
  }


}

